import { SYNC_MEDIA_REASONS } from '../../../../helpers/shopify/resolveSyncMediaSelectionState';
import localization from '../../../../shared/strings';

const VALIDATION_STRINGS = localization.DIALOGS.PRODUCT_DIALOGS.CONNECT_CHANNEL.MEDIA_VALIDATION;

/**
 * Tooltip when Sync media Confirm is disabled by hard-selected media (PCS-11014 Bug 9).
 *
 * @param {{
 *   hasHardSelected?: boolean,
 *   primaryReason?: string|null,
 *   hardCount?: number,
 * }} aggregate
 * @returns {string|null}
 */
export default function getSyncMediaConfirmDisabledTooltip(aggregate) {
  if (!aggregate?.hasHardSelected || !aggregate.primaryReason) {
    return null;
  }

  const count = aggregate.hardCount || 1;

  switch (aggregate.primaryReason) {
  case SYNC_MEDIA_REASONS.THUMBNAIL_PROCESSING:
    return VALIDATION_STRINGS.CONFIRM_DISABLED_MEDIA_PROCESSING(count);
  case SYNC_MEDIA_REASONS.THUMBNAIL_FAILED:
    return VALIDATION_STRINGS.CONFIRM_DISABLED_MEDIA_FAILED(count);
  case SYNC_MEDIA_REASONS.THUMBNAIL_MISSING:
    return VALIDATION_STRINGS.CONFIRM_DISABLED_MEDIA_MISSING(count);
  case SYNC_MEDIA_REASONS.UNSUPPORTED_MEDIA_TYPE:
    return VALIDATION_STRINGS.CONFIRM_DISABLED_MEDIA_UNSUPPORTED(count);
  default:
    return null;
  }
}
